export default {
    'app': 'Please check your Authentication app and enter the 6-digit code in the box below to continue:',
    'sms': 'You should receive a text message with a 6 digit code. Please enter it below:',
    'email': 'Please check your email for a 6 digit code to enter below:'
}